import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import register from '../components/register/register.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		// name: 'Home',
		component: index,
		children: [{
				path: '', //首页
				component: (resolve) => require(['@/views/homePage/homePage.vue'], resolve),
			},
			{
				path: 'organization', //组织机构
				component: (resolve) => require(['@/views/navigation/organization/organization.vue'], resolve),
			},
			{
				path: 'welcome', //欢迎词
				component: (resolve) => require(['@/views/navigation/welcome/welcome.vue'], resolve),
			},
			
			{
				path: 'guide', // 会议指南
				component: (resolve) => require(['@/views/navigation/guide/guide.vue'], resolve),
			},
			{
				path: 'download', // 资料下载
				component: (resolve) => require(['@/views/navigation/download/download.vue'], resolve),
			}

		]
	},
	{
		path: '/register', // 注册
		name: 'register',
		component: register
	},
	{
		path: '/stay', // 征文投稿
		name: 'stay',
		component: (resolve) => require(['@/views/navigation/stay/stay.vue'], resolve),
	},
	{
		path: '/registerSuccess', // 注册成功
		name: 'registerSuccess',
		component: (resolve) => require(['@/views/registerSuccess/registerSuccess.vue'], resolve),
	},
	{
		path:'/xx_regist_succ',//线下注册成功
		name:'xx_regist_succ',
		component: (resolve) => require(['@/views/registerSuccess/xx_regist_succ.vue'], resolve),
	},
	{
		path:'/LivePage',//本站直播首页
		name:'LivePage',
		component: (resolve) => require(['@/views/LivePage/LivePage.vue'], resolve),
	},
	{
		path: '/weixin', //微信登录
		name: 'weixin',
		component: (resolve) => require(['@/views/weixinLogin/weixinLogin.vue'], resolve),
	},
	{
		path: '/pcLogin', //微信登录
		name: 'pcLogin',
		component: (resolve) => require(['@/views/weixinLogin/weixinPcLogin.vue'], resolve),
	},
	{
		path: '/phone', //移动端首页
		name: 'phone',
		component: (resolve) => require(['@/views/phone/index.vue'], resolve),
	},
	{
		path: '/welcome-phone', //移动端欢迎词
		name: 'welcome-phone',
		component: (resolve) => require(['@/views/phoneyemian/welcome/welcome.vue'], resolve),
	},
	{
		path: '/stay-phone', //移动端征文投稿
		name: 'stay-phone',
		component: (resolve) => require(['@/views/phoneyemian/stay/stay.vue'], resolve),
	},
	{
		path: '/wonderful', //移动端精彩瞬间
		name: 'wonderful',
		component: (resolve) => require(['@/views/phoneyemian/wonderful/wonderful.vue'], resolve),
	},
	{
		path: '/organization-phone', //移动端组织机构
		name: 'organization-phone',
		component: (resolve) => require(['@/views/phoneyemian/organization/organization.vue'], resolve),
	},
	{
		path: '/schedule-phone', //移动端大会日程
		name: 'schedule-phone',
		component: (resolve) => require(['@/views/phoneyemian/schedule/schedule.vue'], resolve),
	},
	{
		path: '/download-phone', //移动端资料下载
		name: 'download-phone',
		component: (resolve) => require(['@/views/phoneyemian/download/download.vue'], resolve),
	},
	{
		path: '/contact', //移动端联系我们
		name: 'contact',
		component: (resolve) => require(['@/views/phoneyemian/contact/contact.vue'], resolve),
	},
	{
		path: '/guide-phone', //移动端会议指南
		name: 'guide-phone',
		component: (resolve) => require(['@/views/phoneyemian/guide/guide.vue'], resolve),
	},
	{
		path: '/stay-phone', //移动端住宿安排
		name: 'stay-phone',
		component: (resolve) => require(['@/views/phoneyemian/stay/stay.vue'], resolve),
	},
	{
		path: '/daily', //每日会讯
		name: 'daily',
		component: (resolve) => require(['@/views/phoneyemian/daily/daily.vue'], resolve),
	},
	{
		path: '/seleteSignln', //选择注册页面
		name: 'seleteSignln',
		component: (resolve) => require(['@/views/seleteSignln/seleteSignln.vue'], resolve),
	},
	{
		path: '/signIn', //登录
		name: 'signIn',
		component: (resolve) => require(['@/views/SignIn/SignIn.vue'], resolve),
	},
	{
		path: '/details', //大会直播里面的点击详情页面
		name: 'details',
		component: (resolve) => require(['@/views/details/details.vue'], resolve),
	},
	{
		path: '/schedule', // 大会日程
		component: (resolve) => require(['@/views/navigation/schedule/schedule.vue'], resolve),
	},
	{
		path: '/seleteLive', // 选择进入直播时的菜单
		component: (resolve) => require(['@/views/seleteLive/seleteLive.vue'], resolve),
	},
	{
		path: '/live', //直播
		name: 'live',
		component: (resolve) => require(['@/views/liveBroadcast/liveBroadcast.vue'], resolve),
	},
	{
		path: '/personalCenter', //完成登录
		name: 'personalCenter',
		component: (resolve) => require(['@/views/personalCenter/personalCenter.vue'], resolve),
	},
	{
		path: '/phoneLive', //手机端直播
		name: 'phoneLive',
		component: (resolve) => require(['@/views/liveBroadcast/phone/phone.vue'], resolve),
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '/teamRegister',
		name: 'teamRegister',
		component: (resolve) => require(['@/views/excelRegister/teamRegister.vue'], resolve),
	},
	{
		path: '/userAuth',
		name: 'userAuth',
		component: (resolve) => require(['@/views/SignIn/openNewLiveSigin.vue'], resolve),
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})



const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
	 // chrome
	    document.body.scrollTop = 0
	    // firefox
	    document.documentElement.scrollTop = 0
	    // safari
	    window.pageYOffset = 0

	if (to.path == '/live' && !localStorage.getItem('user')) {
		next({
			name: 'signIn'
		});
	} else {
		next()
	};
	
	
})


export default router
